import styled from 'styled-components';
import { BREAK_POINTS } from '@constants/common/breakpoints';

export const FlexContainer = styled.div`
    display: flex;
    gap: 20px;
    flex-direction: column;
    justify-content: flex-start;
`;

export const StyledInputContainer = styled(FlexContainer)`
    width: 100%;
    align-items: center;
    .gi-input__input {
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        /* Remove Firefox spin buttons */
        &[type='number'] {
            -moz-appearance: textfield;
        }
    };
    @media (max-width: 639px) {
        .gi-button {
            width: fit-content;
            margin: 0;
            margin-bottom: 1rem;
        }
    }
`;

export const FlexRow = styled.div`
    display: flex;
    flex: 1;
    gap: 20px;
    flex-direction: row;
`;

export const StyledDiv = styled.div``;
export const StyledTranscriptionDiv = styled.div`
    #transcription {
        width: 100%; 
        float: none;
        position: inherit;
    }
    @media (max-width: ${BREAK_POINTS.lg}) {
        #transcription {
            tr td:first-child {
                white-space: unset;
            }
        }
    }
`;

export const StyledContainer = styled(StyledDiv)`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: auto;
    max-height: 100%;
    max-width: 100%;
 `;

export const StyledFlexContainerWithBorder = styled(FlexContainer)`
    border: ${({ theme }) => `1px solid ${theme.gray8}`};
    padding: 10px;
 `;

export const StyledText = styled.p``;

export const StyledInteractionHeading = styled(StyledText)`
    font-weight: 600;
    font-size: 2.2rem;
    margin-bottom: 10px;
    text-align: center;
`;

export const StyledMediaContainer = styled(StyledDiv)`
    width: 100%;
    height: 100%;
    aspect-ratio: 16 / 9;
 `;

export const StyledMediaLayoutContainer = styled(StyledDiv)`
    min-width: 100%;
    margin-left: auto;
    margin-right: auto;
    min-height: calc(100vh - 290px);
    padding: 20px;
 `;

export const StyledGridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(457px, 1fr));
    grid-gap: 20px;
 `;